/**
 * @file all-insights.js
 */
import {getResultCountHtml} from "./view-helpers";

(function ($, Drupal, drupalSettings, once) {
  'use strict';

  function updateResultCountAllInsights() {
    let pagesCurrentItem = document.querySelector('.insights-display span[data-pages-current]');
    let resultsDisplay = document.getElementById('resultCount');

    if (pagesCurrentItem && resultsDisplay) {
      const pagesCurrent = parseInt(pagesCurrentItem.textContent);
      const itemsPerPage = parseInt(document.querySelector('.insights-display span[data-items-per-page]').textContent);
      const itemsTotal = parseInt(document.querySelector('.insights-display span[data-items-total]').textContent);
      resultsDisplay.innerHTML = getResultCountHtml(pagesCurrent, itemsPerPage, itemsTotal);
    } else {
      if (resultsDisplay) {
        resultsDisplay.innerHTML = '';
      }
    }
    $('.bef-link').each(function () {
      if ($(this).text().trim() === '- Any -') {
        $(this).text('All'); // Replace the text
      }
    });
  }

  Drupal.behaviors.kodakAllInsights = {
    attach: function (context, settings) {
      once('AllInsightsBlock', '.paragraph--type--all-insights-block', context).forEach((element) => {
        updateResultCountAllInsights();
      });
    }
  };

  // Re-apply the behavior and update result count on AJAX updates.
  $(document).ajaxComplete(function () {
    if ($('.paragraph--type--all-insights-block').length) {
      // Re-attach the behavior with the document context to handle all elements.
      Drupal.behaviors.kodakAllInsights.attach(document, drupalSettings);
      // Call updateResultCount again to update the result count after AJAX completes
      updateResultCountAllInsights();
    }
  });

})(jQuery, Drupal, drupalSettings, once);
